import Field from '../form/field';
import intlTelInput from 'intl-tel-input';

const name = 'field-phone';

export default class FormPhone extends Field {

  constructor($el) {
    super($el, 'form-phone');

    // FormField element.
    this.$field = this.$el.querySelector('.' + name + '__phone');

    // Input field rendered for users.
    this.$input = this.$el.querySelector('.' + name + '__phone .form-field__input');
    this.name = this.$input.name;

    // Placeholder.
    this.$placeholder = this.$el.querySelector('.' + name + '__phone ' + '.form-field__placeholder');

    // Render library field.
    // Note that following attributes were not used:
    // - utilsScript: adds another big script that was not working correctly for
    // me and potentially can be avoided.
    // - hiddenInput: requires utilsScript, didn't work, adds yet another hidden
    // field.
    this.$iti = intlTelInput(this.$input, {
      preferredCountries: ['de', 'at', 'ch'], // DACH countries.
    });

    // Bind events and call initial change event
    this.$input.oninput = this.onChange.bind(this);
  }

  /**
   * Triggered on value change. Prepends country code to input.
   */
  onChange() {
    // Disallow non-numerical symbols.
    this.$input.value = this.$input.value.trim().replace(/[^0-9]/g, '');

    // Disallow the 0 as the first symbol.
    if (this.$input.value == 0) {
      this.$input.value = '';
    }

    // Make sure phone is not empty after modifications.
    if (this.$input.value !== null && this.$input.value !== '') {
      // Set filled modifier for styling.
      this.$el.classList.add(name + '__phone--filled');
    }

    // Validate on every change
    this.validate();
  }

  getCountryCode () {
    return this.$iti.selectedCountryData.dialCode;
  }

  getValue () {
    var value = this.$input.value;
    if (value !== null && value !== '') {
      value = '+' + this.getCountryCode() + value;
    }
    else {
      value = '';
    }

    return value;
  }

  validate () {
    this.setValid(true);

    if (!this.shouldValidate) {
      // Skip validation if field should not be validated
      return true;
    }

    // Verify if field is required
    if (this.required) {
      const value = this.getValue();

      if (value == '' || value == this.getCountryCode()) {
        this.setValid(false);
      }
    }

    return this.valid;
  }

  /**
   * Sets wether this field is valid.
   * @param {boolean} valid
   */
  setValid (valid) {
    if (this.valid !== valid) {
      this.valid = valid;

      // Update invalid modifier
      this.$el.classList.toggle(`${this.classname}--invalid`, !valid);

      // As this field uses a FormField object in the template, we need to
      // update it too.
      if (!valid) {
        this.$field.classList.add('form-field--invalid');
        this.$field.classList.add('form-field--placeholder');
        this.$placeholder.innerText = this.$el.dataset.messageRequired;
      }
      else {
        this.$field.classList.remove('form-field--invalid');
        this.$field.classList.remove('form-field--placeholder');
        this.$placeholder.innerText = '';
      }

      // Inform delegate about this
      this.delegate && this.delegate.fieldValidDidChange(this, valid);
    }

    return this;
  }
}
